$('#Field325').change(function(){
  if ($(this).is(':checked')) {
    $('#foli426').show();
    $('#Field326').prop('checked', false);
  }
});

$('#Field326').change(function(){
  if ($(this).is(':checked')) {
    $('#foli426').hide();
    $('#Field325').prop('checked', false);
  }
});

$('#Field427').change(function(){
  if ($(this).is(':checked')) {
    $('#foli527').show();
    $('#Field428').prop('checked', false);
  }
});

$('#Field428').change(function(){
  if ($(this).is(':checked')) {
    $('#foli527').hide();
    $('#Field427').prop('checked', false);
  }
});

$('#Field528').change(function(){
  if ($(this).is(':checked')) {
    $('#foli628').show();
    $('#Field529').prop('checked', false);
  }
});

$('#Field529').change(function(){
  if ($(this).is(':checked')) {
    $('#foli628').hide();
    $('#Field528').prop('checked', false);
  }
});